module.exports = __webpack_public_path__ + "static/media/checkmark.1751e96d.svg";